import { apiClient } from "@/utils/apiClient/apiClient";
import { PlacedObject, ProjectData } from "../../../components/types";

export const updatePlacedObject = async (
  projectId: string,
  updatedObject: PlacedObject,
  currentProjectData: ProjectData | null
): Promise<void> => {
  try {
    if (!currentProjectData) {
      throw new Error("No current project data available");
    }

    // Update the specific object in the objects array
    const currentObjects = currentProjectData.objects || [];
    const updatedObjects = currentObjects.map((obj) =>
      obj.id === updatedObject.id ? updatedObject : obj
    );

    // Verify that the object was found and updated
    const objectExists = currentObjects.some(
      (obj) => obj.id === updatedObject.id
    );
    if (!objectExists) {
      console.warn(
        `Object with id ${updatedObject.id} not found in current project data`
      );
    }

    // Create the project update data with the updated objects array
    const projectUpdateData = {
      objects: updatedObjects,
    };

    console.log("Updating project with objects:", projectUpdateData);

    const response = await apiClient.updateProject(
      projectId,
      projectUpdateData
    );

    console.log("response update project objects: ", response);

    // The response should contain the updated project data
    if (!response) {
      throw new Error("Failed to update object: No response received");
    }
    // No need to return anything if the update is successful
  } catch (error) {
    console.error("Error updating placed object:", error);
    // Re-throw the error to be handled by the calling component
    throw error;
  }
};
